var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgNoMatchData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 290 210",
    style: {
      enableBackground: "new 0 0 290 210"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.1;fill:#93a5f6;enable-background:new    ;}\r\n\t.st1{fill:#FFFFFF;stroke:#93a5f6;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#93a5f6;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st3{opacity:0.4;}\r\n\t.st4{fill:none;stroke:#93a5f6;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st5{opacity:0.5;fill:#93a5f6;enable-background:new    ;}\r\n\t.st6{opacity:0.2;fill:#93a5f6;enable-background:new    ;}\r\n\t.st7{opacity:0.3;fill:#93a5f6;enable-background:new    ;}\r\n\t.st8{opacity:0.2;}\r\n\t.st9{fill:#93a5f6;}\r\n\t.st10{fill:#93a5f6;}\r\n\t.st11{opacity:0.4;fill:#93a5f6;enable-background:new    ;}\r\n\t\r\n\t\t.st12{opacity:0.5;fill:#FFFFFF;stroke:#93a5f6;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;enable-background:new    ;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 145,
    cy: 105,
    r: 100
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.7,36.9l-2.3-6.4c-0.3-1-1.2-1.7-2.3-1.8L208.9,27c-1.5-0.2-2.8,0.9-2.9,2.4l-4.1,39.2 c-0.2,1.5,0.9,2.8,2.4,2.9l55.1,5.7c1.5,0.2,2.8-0.9,2.9-2.4l3.1-29.9c0.2-1.5-0.9-2.8-2.4-2.9l-31-3.2 C230.9,38.7,230,37.9,229.7,36.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.7,32l-1.4-6.7c-0.2-1-1-1.9-2-2.1l-15.8-3.9c-1.4-0.4-2.9,0.5-3.2,2l-9.4,38.3c-0.4,1.4,0.5,2.9,2,3.2 L267.7,76c1.4,0.4,2.9-0.5,3.2-2l7.1-29.2c0.4-1.4-0.5-2.9-2-3.2l-30.3-7.4C244.7,33.8,243.9,33,243.7,32z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 5,
    y1: 179.2,
    x2: 285,
    y2: 179.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.7,91.2c2-1.4,4.8-1,6.2,1l28.9,39.9c1.4,2,1,4.8-1,6.2l-29,21c-2,1.4-4.8,1-6.2-1L7.7,118.4 c-1.4-2-1-4.8,1-6.2L37.7,91.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.2,95.1l25-13.4c2.2-1.2,4.9-0.3,6.1,1.8l23.3,43.4c1.2,2.2,0.3,4.9-1.8,6.1l-31.5,16.9 c-2.2,1.2-4.9,0.3-6.1-1.8l-20-37.2c-0.6-1.1-0.7-2.4-0.3-3.5l3.2-9.6C21.4,96.6,22.2,95.7,23.2,95.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.7,97.6l2.4,4.5c1,1.9,0.3,4.2-1.6,5.2l-4.5,2.4"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 35.8,
    y1: 111.2,
    x2: 55.6,
    y2: 100.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 28.9,
    y1: 114.9,
    x2: 30.9,
    y2: 113.9
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 39,
    y1: 117.1,
    x2: 58.7,
    y2: 106.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 32.1,
    y1: 120.8,
    x2: 34.1,
    y2: 119.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 42.2,
    y1: 123,
    x2: 61.9,
    y2: 112.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 35.3,
    y1: 126.7,
    x2: 37.3,
    y2: 125.7
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 45.4,
    y1: 129,
    x2: 65.1,
    y2: 118.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 38.5,
    y1: 132.7,
    x2: 40.4,
    y2: 131.6
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 48.5,
    y1: 134.9,
    x2: 68.2,
    y2: 124.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 41.6,
    y1: 138.6,
    x2: 43.6,
    y2: 137.5
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 34.6,
    cy: 61.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 129.6,
    cy: 29.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 255.6,
    cy: 100.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 152.6,
    cy: 37.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 255.6,
    cy: 153.4,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 246.6,
    cy: 130.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 17.6,
    cy: 160.2,
    r: 3
  }), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.9,
    y: 172.5,
    className: "st9",
    width: 1.3,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.6,
    y: 174.8,
    className: "st9",
    width: 6,
    height: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 190.9,
    y: 25.5,
    className: "st9",
    width: 1.3,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.6,
    y: 27.8,
    className: "st9",
    width: 6,
    height: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273.9,
    y: 120.7,
    className: "st9",
    width: 1.3,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.6,
    y: 123,
    className: "st9",
    width: 6,
    height: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.8,
    y: 26.5,
    className: "st9",
    width: 1.3,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.4,
    y: 28.9,
    className: "st9",
    width: 6,
    height: 1.3
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 201.9,
    y: 174.5,
    className: "st9",
    width: 1.3,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.6,
    y: 176.8,
    className: "st9",
    width: 6,
    height: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236,179.5H54c-2.2,0-4-1.8-4-4v-122c0-2.2,1.8-4,4-4h182c2.2,0,4,1.8,4,4v122 C240,177.7,238.2,179.5,236,179.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 50.1,
    y1: 72.4,
    x2: 239,
    y2: 72.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 61.9,
    cy: 60.9,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 71.7,
    cy: 60.9,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 81.4,
    cy: 60.9,
    r: 2.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M83.2,120.7H62.4c-1,0-1.8-0.8-1.8-1.8v-1.3c0-1,0.8-1.8,1.8-1.8h20.8c1,0,1.8,0.8,1.8,1.8v1.3 C85,119.9,84.2,120.7,83.2,120.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M112.6,120.7H91.8c-1,0-1.8-0.8-1.8-1.8v-1.3c0-1,0.8-1.8,1.8-1.8h20.8c1,0,1.8,0.8,1.8,1.8v1.3 C114.4,119.9,113.6,120.7,112.6,120.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M227.6,120.7H121.1c-1,0-1.8-0.8-1.8-1.8v-1.3c0-1,0.8-1.8,1.8-1.8h106.5c1,0,1.8,0.8,1.8,1.8v1.3 C229.4,119.9,228.6,120.7,227.6,120.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M83.2,137.8H62.4c-1,0-1.8-0.8-1.8-1.8v-1.3c0-1,0.8-1.8,1.8-1.8h20.8c1,0,1.8,0.8,1.8,1.8v1.3 C85,137,84.2,137.8,83.2,137.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M112.6,137.8H91.8c-1,0-1.8-0.8-1.8-1.8v-1.3c0-1,0.8-1.8,1.8-1.8h20.8c1,0,1.8,0.8,1.8,1.8v1.3 C114.4,137,113.6,137.8,112.6,137.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M227.6,137.8H121.1c-1,0-1.8-0.8-1.8-1.8v-1.3c0-1,0.8-1.8,1.8-1.8h106.5c1,0,1.8,0.8,1.8,1.8v1.3 C229.4,137,228.6,137.8,227.6,137.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M83.2,154.9H62.4c-1,0-1.8-0.8-1.8-1.8v-1.3c0-1,0.8-1.8,1.8-1.8h20.8c1,0,1.8,0.8,1.8,1.8v1.3 C85,154.1,84.2,154.9,83.2,154.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M112.6,154.9H91.8c-1,0-1.8-0.8-1.8-1.8v-1.3c0-1,0.8-1.8,1.8-1.8h20.8c1,0,1.8,0.8,1.8,1.8v1.3 C114.4,154.1,113.6,154.9,112.6,154.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M227.6,154.9H121.1c-1,0-1.8-0.8-1.8-1.8v-1.3c0-1,0.8-1.8,1.8-1.8h106.5c1,0,1.8,0.8,1.8,1.8v1.3 C229.4,154.1,228.6,154.9,227.6,154.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M100,103.8H62.6c-1.1,0-2-0.9-2-2v-6.4c0-1.1,0.9-2,2-2H100c1.1,0,2,0.9,2,2v6.4 C102,102.9,101.1,103.8,100,103.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M227.4,103.8h-73.7c-1.1,0-2-0.9-2-2v-6.4c0-1.1,0.9-2,2-2h73.7c1.1,0,2,0.9,2,2v6.4 C229.4,102.9,228.5,103.8,227.4,103.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st12",
    cx: 177.9,
    cy: 116.8,
    rx: 33.3,
    ry: 33.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 177.9,
    cy: 116.8,
    rx: 33.3,
    ry: 33.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200.1,102.3c0.4,0.6,0.8,1.2,1.1,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M159.2,98.1c10-10,26-10.3,36.4-1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 201.4,
    y1: 140.3,
    x2: 205.3,
    y2: 144.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.6,168.3l-4.2,4.2c-1.4,1.4-3.6,1.4-4.9,0l-19.9-19.9c-1.4-1.4-1.4-3.6,0-5l4.2-4.2 c1.4-1.4,3.6-1.4,4.9,0l19.9,19.9C235,164.7,235,166.9,233.6,168.3z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 209.9,
    y1: 158,
    x2: 219.1,
    y2: 148.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNoMatchData);
export default __webpack_public_path__ + "static/media/img_noMatchData.b55b1282e35a70cb7a81380283e4452b.svg";
export { ForwardRef as ReactComponent };